import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TTCUser } from '../../interfaces/services/tid';
import { ApiStatus } from '../../utils/enums';

const initialUser: TTCUser = {
    email: '',
    name: '',
    firstName: '',
    lastName: '',
    tidType: '',
    accounts: [],
    status: '',
    accountId: '',
    accountName: '',
    roles: [],
    lastVisited: '',
    ttcUserObjectId: '',
    accountObjectId: '',
    userRole: '',
    id: '',
};

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        userLoginStatus: ApiStatus.Idle,
        userDetails: initialUser,
    },
    reducers: {
        resetUserDetails: (state) => {
            state.userDetails = initialUser;
        },
        updateUserDetails: (state, action: PayloadAction<TTCUser>) => {
            state.userDetails = action.payload;
        },
        updateUserLoginStatus: (state, action: PayloadAction<ApiStatus>) => {
            state.userLoginStatus = action.payload;
        },
    },
});

export default userSlice.reducer;

export const {
    resetUserDetails,
    updateUserDetails,
    updateUserLoginStatus,
} = userSlice.actions;
